// @ts-nocheck
/**
 * Atelier Finery Product Configurator — Steps 1,3,4 cart + Step 2 AI mockups (Gemini Worker + R2)
 */
(function () {
  'use strict';

  const CONFIG = {
    minimumOrder: 12,
    screenPrintMinimum: 24,
    quoteThreshold: 144,
    additionalLogoProductHandle: 'additional-logo-placement',
    extendedSizeProductHandle: 'extended-size-surcharge',
    additionalLogoPrice: 4,
    extendedSizeSurcharge: 3,
    extendedSizes: ['2XL', '3XL', 'XXL', 'XXXL'],
  };

  const LOGO_PRESETS = [
    { label: 'White', hex: '#FFFFFF' },
    { label: 'Black', hex: '#000000' },
    { label: 'Navy', hex: '#001F3F' },
    { label: 'Red', hex: '#C41E3A' },
    { label: 'Gold', hex: '#D4AF37' },
  ];

  /** Approximate % boxes on flat lay for “your logo here” guides (per placement key / back zone). */
  const PREVIEW_GUIDES = {
    front: {
      left_chest: { top: '26%', left: '36%', width: '15%', height: '14%' },
      right_chest: { top: '26%', left: '52%', width: '15%', height: '14%' },
      garment_front: { top: '28%', left: '30%', width: '40%', height: '42%' },
      center_front: { top: '30%', left: '38%', width: '24%', height: '22%' },
      default: { top: '28%', left: '38%', width: '22%', height: '20%' },
    },
    back: {
      upper: { top: '18%', left: '32%', width: '36%', height: '22%' },
      mid: { top: '38%', left: '32%', width: '36%', height: '26%' },
      full: { top: '22%', left: '25%', width: '50%', height: '52%' },
      garment_back: { top: '28%', left: '32%', width: '36%', height: '38%' },
      default: { top: '28%', left: '32%', width: '36%', height: '38%' },
    },
    side: {
      left_sleeve: { top: '32%', left: '18%', width: '20%', height: '26%' },
      right_sleeve: { top: '32%', left: '58%', width: '20%', height: '26%' },
      default: { top: '30%', left: '36%', width: '28%', height: '32%' },
    },
  };

  /** Default inner guides (0–1 within maxRect); merged with printPreviewGeometry.guides from Shopify. */
  const GEOMETRY_DEFAULT_GUIDES = {
    left_chest: { x: 0.08, y: 0.12, w: 0.28, h: 0.22 },
    right_chest: { x: 0.64, y: 0.12, w: 0.28, h: 0.22 },
    center_front: { x: 0.36, y: 0.18, w: 0.28, h: 0.22 },
    garment_front: { x: 0.15, y: 0.12, w: 0.7, h: 0.58 },
    garment_back: { x: 0.18, y: 0.14, w: 0.64, h: 0.52 },
    left_sleeve: { x: 0.08, y: 0.22, w: 0.24, h: 0.32 },
    right_sleeve: { x: 0.68, y: 0.22, w: 0.24, h: 0.32 },
    hat_front: { x: 0.22, y: 0.18, w: 0.56, h: 0.38 },
    hat_back: { x: 0.22, y: 0.18, w: 0.56, h: 0.38 },
    apron_front: { x: 0.18, y: 0.16, w: 0.64, h: 0.48 },
  };

  function mergedGeometryGuides(geo) {
    const base = { ...GEOMETRY_DEFAULT_GUIDES };
    if (geo?.guides && typeof geo.guides === 'object') {
      Object.assign(base, geo.guides);
    }
    // Placement-key aliases: metaobject handles use short names like "front"
    // while the geometry guides use canonical "garment_front" keys.
    const aliases = {
      front: 'garment_front',
      back: 'garment_back',
    };
    for (const [alias, canonical] of Object.entries(aliases)) {
      if (!base[alias] && base[canonical]) {
        base[alias] = base[canonical];
      }
    }
    return base;
  }

  /**
   * Shopify often outputs JSON metaobject fields as a string inside the payload; numbers may be strings too.
   */
  function parsePrintPreviewGeometry(raw) {
    if (raw == null || raw === '') return null;
    let g = raw;
    if (typeof g === 'string') {
      try {
        g = JSON.parse(g);
      } catch {
        return null;
      }
    }
    if (!g || typeof g !== 'object' || !g.views || typeof g.views !== 'object') return null;
    const views = { ...g.views };
    for (const vk of ['front', 'back', 'side']) {
      const v = views[vk];
      if (!v || typeof v !== 'object' || !v.maxRect) continue;
      const mr = v.maxRect;
      const w = Number(mr.w);
      const h = Number(mr.h);
      if (!Number.isFinite(w) || w <= 0 || !Number.isFinite(h) || h <= 0) continue;
      views[vk] = {
        ...v,
        maxRect: {
          x: Number.isFinite(Number(mr.x)) ? Number(mr.x) : 0,
          y: Number.isFinite(Number(mr.y)) ? Number(mr.y) : 0,
          w,
          h,
        },
      };
    }
    return { ...g, views };
  }

  function getMaxRectForView(view) {
    const geo = state.productData?.printPreviewGeometry;
    const r = geo?.views?.[view]?.maxRect;
    if (!r) return null;
    const w = Number(r.w);
    const h = Number(r.h);
    if (!Number.isFinite(w) || w <= 0 || !Number.isFinite(h) || h <= 0) return null;
    return {
      x: Number.isFinite(Number(r.x)) ? Number(r.x) : 0,
      y: Number.isFinite(Number(r.y)) ? Number(r.y) : 0,
      w,
      h,
    };
  }

  function innerGuideToCssPct(inner, maxRect) {
    const abs = {
      x: maxRect.x + inner.x * maxRect.w,
      y: maxRect.y + inner.y * maxRect.h,
      w: inner.w * maxRect.w,
      h: inner.h * maxRect.h,
    };
    return {
      top: `${abs.y * 100}%`,
      left: `${abs.x * 100}%`,
      width: `${abs.w * 100}%`,
      height: `${abs.h * 100}%`,
    };
  }

  /**
   * Maps geometry JSON (0–1 in image space) to the preview frame (CSS object-fit: contain).
   * @returns {{ ox: number, oy: number, dw: number, dh: number, fw: number, fh: number, iw: number, ih: number } | null}
   */
  function getFlatPreviewImageLayout() {
    const img = document.getElementById('atelier-flat-preview-img');
    const frame = document.getElementById('atelier-flat-preview-frame');
    if (!img || !frame) return null;
    const iw = img.naturalWidth;
    const ih = img.naturalHeight;
    if (!iw || !ih) return null;
    const fw = frame.clientWidth;
    const fh = frame.clientHeight;
    if (fw <= 0 || fh <= 0) return null;
    const scale = Math.min(fw / iw, fh / ih);
    const dw = iw * scale;
    const dh = ih * scale;
    const ox = (fw - dw) / 2;
    const oy = (fh - dh) / 2;
    return { ox, oy, dw, dh, fw, fh, iw, ih };
  }

  /** { x, y, w, h } in image-normalized 0–1 → % of preview frame. */
  function image01RectToFramePercentStyle(rect, layout) {
    if (!rect || !layout) return null;
    const { ox, oy, dw, dh, fw, fh } = layout;
    const left = ((ox + rect.x * dw) / fw) * 100;
    const top = ((oy + rect.y * dh) / fh) * 100;
    const w = ((rect.w * dw) / fw) * 100;
    const h = ((rect.h * dh) / fh) * 100;
    return {
      top: `${top}%`,
      left: `${left}%`,
      width: `${w}%`,
      height: `${h}%`,
    };
  }

  /** Image-normalized point → % left/top for absolutely positioned center (translate -50%,-50%). */
  function image01PointToFramePercent(cx, cy, layout) {
    if (!layout) {
      return { left: `${cx * 100}%`, top: `${cy * 100}%` };
    }
    const { ox, oy, dw, dh, fw, fh } = layout;
    const fx = ox + cx * dw;
    const fy = oy + cy * dh;
    return { left: `${(fx / fw) * 100}%`, top: `${(fy / fh) * 100}%` };
  }

  /** Frame-relative pointer 0–1 → image-normalized 0–1 (inverse of contain). */
  function frame01ToImage01(px, py, layout) {
    if (!layout) {
      return { ix: px, iy: py };
    }
    const { ox, oy, dw, dh, fw, fh } = layout;
    const xPx = px * fw;
    const yPx = py * fh;
    return {
      ix: (xPx - ox) / dw,
      iy: (yPx - oy) / dh,
    };
  }

  function getMockupConfig() {
    const el = document.getElementById('atelier-mockup-config');
    if (!el) return { workerUrl: '', storeDomain: '', brandLabel: '', watermarkImageUrl: null };
    try {
      return JSON.parse(el.textContent);
    } catch {
      return { workerUrl: '', storeDomain: '', brandLabel: '', watermarkImageUrl: null };
    }
  }

  const state = {
    currentStep: 1,
    maxUnlockedStep: 1,
    productData: null,
    sessionId: null,

    selectedMethod: null,
    selectedMethodVariantId: null,
    selectedMethodPrice: 0,

    selectedColor: null,
    selectedGarmentColor: null,

    selectedLocations: [],
    /** @type {Record<string, number>} placementKey → visual scale on flat preview (≈1 = default) */
    placementLogoScale: {},
    /** Flat studio toggle: which garment face’s image and placements are shown */
    flatPreviewFace: 'front',
    /** @type {Array<{ id: string, fileName: string, dataUrl: string }>} */
    logoLibrary: [],
    /** @type {Record<string, string>} placementKey -> library id */
    placementLogoChoice: {},
    /** @type {Record<string, { dataUrl: string, fileName: string }>} resolved from library */
    placementLogos: {},
    /** @type {Record<string, { x: number, y: number }>} normalized center within maxRect (0–1) */
    logoDragNorm: {},
    logoColorMode: 'original',
    logoColorLabel: 'White',
    logoColorHex: '#FFFFFF',

    specialInstructions: '',

    sizeBreakdown: {},
    totalQuantity: 0,
    extendedSizeCount: 0,

    additionalLogoVariantId: null,
    extendedSizeVariantId: null,

    mockupPhase: 'form',
    /** True after at least one successful full generate; allows continuing without re-running AI. */
    mockupReady: false,
    mockupPlacements: [],
    mockupErrors: [],
  };

  function init() {
    const payloadEl = document.getElementById('atelier-configurator-payload');
    if (payloadEl) {
      try {
        state.productData = JSON.parse(payloadEl.textContent);
        if (state.productData) {
          state.productData.printPreviewGeometry = parsePrintPreviewGeometry(
            state.productData.printPreviewGeometry
          );
          state.productData.colorFlatByHandle =
            normalizeColorFlatMap(state.productData.colorFlatByHandle) || {};
        }
      } catch (e) {
        console.error('Failed to parse product data:', e);
      }
    }

    fetchAddonProducts();
    bindModalControls();
    bindStep1Controls();
    bindMockupStep2();
    bindStep3Controls();
    bindStep4Controls();
  }

  async function fetchAddonProducts() {
    try {
      const logoProduct = await fetchProductByHandle(CONFIG.additionalLogoProductHandle);
      if (logoProduct?.variants?.[0]) state.additionalLogoVariantId = logoProduct.variants[0].id;
      const sizeProduct = await fetchProductByHandle(CONFIG.extendedSizeProductHandle);
      if (sizeProduct?.variants?.[0]) state.extendedSizeVariantId = sizeProduct.variants[0].id;
    } catch (e) {
      console.warn('Could not fetch add-on products:', e);
    }
  }

  async function fetchProductByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) return null;
      return await response.json();
    } catch {
      return null;
    }
  }

  function bindModalControls() {
    const openBtns = document.querySelectorAll('[data-atelier-open]');
    const closeEls = document.querySelectorAll('[data-atelier-close]');
    const backBtn = document.querySelector('[data-atelier-back]');
    const nextBtn = document.querySelector('[data-atelier-next]');

    openBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        if (btn.tagName === 'A') e.preventDefault();
        openModal();
      });
    });
    closeEls.forEach((el) => el.addEventListener('click', () => closeModal()));
    if (backBtn) backBtn.addEventListener('click', () => navigateStep(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => {
      // On step 2: trigger render (deterministic if calibrated, AI fallback otherwise)
      if (state.currentStep === 2 && !state.mockupReady) {
        generateMockupViaRender();
      } else {
        navigateStep(1);
      }
    });

    document.querySelectorAll('[data-step-indicator]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = parseInt(btn.dataset.stepIndicator, 10);
        if (step <= state.maxUnlockedStep) showStep(step);
      });
    });
  }

  function openModal() {
    const modal = document.querySelector('[data-atelier-modal]');
    if (!modal) return;
    modal.classList.remove('hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    resetState();
    showStep(1);
  }

  function closeModal() {
    const modal = document.querySelector('[data-atelier-modal]');
    if (!modal) return;
    modal.classList.add('hidden');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Artwork library persistence ──────────────────────────────────────────
  const ARTWORK_STORAGE_KEY = 'finery_studio_artwork_v1';

  function saveArtworkLibrary() {
    try { sessionStorage.setItem(ARTWORK_STORAGE_KEY, JSON.stringify(state.logoLibrary)); } catch (e) {}
  }

  function loadArtworkLibrary() {
    try {
      const raw = sessionStorage.getItem(ARTWORK_STORAGE_KEY);
      if (raw) { const lib = JSON.parse(raw); if (Array.isArray(lib)) state.logoLibrary = lib; }
    } catch (e) {}
  }

  function resetState() {
    state.sessionId =
      'sess_' + Math.random().toString(36).substring(2, 11) + '_' + Date.now();
    state.currentStep = 1;
    state.maxUnlockedStep = 1;
    state.selectedMethod = null;
    state.selectedColor = null;
    state.selectedGarmentColor = null;
    state.selectedLocations = [];
    state.placementLogoScale = {};
    state.flatPreviewFace = 'front';
    // logoLibrary: preserved — restored from sessionStorage below
    state.placementLogoChoice = {};
    state.placementLogos = {};
    state.logoDragNorm = {};
    state.logoColorMode = 'original';
    state.logoColorLabel = 'White';
    state.logoColorHex = '#FFFFFF';
    state.specialInstructions = '';
    // sizeBreakdown persists across navigation within the page session
    // (reset only on full page reload via initial state declaration)
    state.mockupPhase = 'form';
    state.mockupReady = false;
    state.mockupPlacements = [];
    state.mockupErrors = [];

    const formEl = document.getElementById('atelier-mockup-form');
    const resEl = document.getElementById('atelier-mockup-results');
    if (formEl) formEl.classList.remove('hidden');
    if (resEl) resEl.classList.add('hidden');

    // Restore artwork library from storage
    loadArtworkLibrary();

    initMockupColors();
    initPlacementRows();
    document.querySelectorAll('input[name="atelier-logo-color-mode"]').forEach((r) => {
      r.checked = r.value === 'original';
    });
    const customEl = document.getElementById('atelier-logo-color-custom');
    if (customEl) customEl.classList.add('hidden');
  }

  function navigateStep(direction) {
    const newStep = state.currentStep + direction;
    if (direction > 0 && !validateCurrentStep()) return;
    if (newStep >= 1 && newStep <= 5) {
      if (direction > 0 && newStep > state.maxUnlockedStep) {
        state.maxUnlockedStep = newStep;
      }
      showStep(newStep);
    }
  }

  function syncMockupStudioLayoutClass() {
    // No-op: layout is handled directly via [data-step="2"] CSS selectors.
  }

  function showStep(stepNumber) {
    state.currentStep = stepNumber;
    document.querySelectorAll('[data-step-indicator]').forEach((indicator) => {
      const step = parseInt(indicator.dataset.stepIndicator, 10);
      indicator.classList.toggle('is-active', step === stepNumber);
      indicator.classList.toggle('is-locked', step > state.maxUnlockedStep);
      indicator.disabled = step > state.maxUnlockedStep;
    });
    document.querySelectorAll('[data-step]').forEach((panel) => {
      const step = parseInt(panel.dataset.step, 10);
      panel.classList.toggle('is-active', step === stepNumber);
    });
    updateFooterButtons();
    syncMockupStudioLayoutClass();
    if (stepNumber === 2) {
      // Ensure design studio form is visible when returning to step 2
      const formEl = document.getElementById('atelier-mockup-form');
      if (formEl) formEl.classList.remove('hidden');
      state.mockupPhase = 'form';
    } else if (stepNumber === 3) {
      // Ensure the results panel is visible (it starts hidden from resetState)
      const resEl = document.getElementById('atelier-mockup-results');
      if (resEl) resEl.classList.remove('hidden');
    } else if (stepNumber === 4) {
      initializeSizeBreakdown();
    } else if (stepNumber === 5) {
      renderSummary();
    }

    // Show/hide footer price on steps 4+
    const footerPrice = document.getElementById('fs-footer-price');
    if (footerPrice) footerPrice.style.display = stepNumber >= 4 ? 'flex' : 'none';

    // Update footer price display
    updateFooterPriceDisplay();
  }

  function updateFooterButtons() {
    const backBtn = document.querySelector('[data-atelier-back]');
    const nextBtn = document.querySelector('[data-atelier-next]');
    if (backBtn) {
      backBtn.style.visibility = state.currentStep === 1 ? 'hidden' : 'visible';
    }
    if (!nextBtn) return;

    if (state.currentStep === 5) {
      nextBtn.style.display = 'none';
      return;
    }
    nextBtn.style.display = 'flex';

    if (state.currentStep === 2) {
      // Hide the inline view/generate buttons — the footer button handles both actions
      const viewBtn = document.getElementById('atelier-view-mockups');
      if (viewBtn) viewBtn.classList.add('hidden');
      if (state.mockupReady) {
        nextBtn.disabled = false;
        nextBtn.textContent = 'Continue to Preview →';
      } else {
        nextBtn.disabled = !placementLogosComplete();
        nextBtn.textContent = 'Generate Preview →';
      }
      return;
    }

    if (state.currentStep === 3) {
      nextBtn.disabled = false;
      nextBtn.textContent = 'Continue to Sizes';
      return;
    }

    nextBtn.disabled = false;
    nextBtn.textContent = state.currentStep === 4 ? 'Review Order' : 'Next';
  }

  function updateFooterPriceDisplay() {
    const amountEl = document.getElementById('fs-footer-price-amount');
    if (!amountEl) return;
    const totalEl = document.getElementById('atelier-price-total');
    if (totalEl && totalEl.textContent !== 'CA$0.00' && totalEl.textContent !== '$0.00') {
      amountEl.textContent = totalEl.textContent;
    }
  }

  function validateCurrentStep() {
    if (state.currentStep === 1) {
      const selected = document.querySelector('input[name="decoration-method"]:checked');
      if (!selected) {
        alert('Please select a print method');
        return false;
      }
      state.selectedMethod = selected.value;
      if (state.productData?.printMethods) {
        const method = state.productData.printMethods.find(
          (m) => m.label.toLowerCase() === state.selectedMethod.toLowerCase()
        );
        if (method) {
          state.selectedMethodVariantId = method.id;
          state.selectedMethodPrice = parseFloat(method.price);
        }
      }
      return true;
    }

    if (state.currentStep === 2) {
      if (!state.selectedGarmentColor) {
        setStep2Validation('Select a garment colour.');
        return false;
      }
      state.selectedColor =
        state.selectedGarmentColor.label || state.selectedGarmentColor.handle || 'Colour';
      const locs = getCheckedPlacements();
      if (locs.length === 0) {
        setStep2Validation('Select at least one print location.');
        return false;
      }
      state.selectedLocations = locs.map((p) => p.key);
      const instr = document.querySelector('[data-special-instructions]');
      state.specialInstructions = instr ? instr.value : '';
      setStep2Validation('');
      return true;
    }

    if (state.currentStep === 4) {
      const totalQty = calculateTotalQuantity();
      if (totalQty < CONFIG.minimumOrder) {
        alert(`Minimum order quantity is ${CONFIG.minimumOrder} units`);
        return false;
      }
      if (
        state.selectedMethod &&
        String(state.selectedMethod).toLowerCase().includes('screen') &&
        totalQty < CONFIG.screenPrintMinimum
      ) {
        alert(`Screen printing requires minimum ${CONFIG.screenPrintMinimum} units`);
        return false;
      }
      return true;
    }

    return true;
  }

  function setStep2Validation(msg) {
    const el = document.getElementById('atelier-step2-validation');
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.classList.remove('hidden');
    } else {
      el.textContent = '';
      el.classList.add('hidden');
    }
  }

  function bindStep1Controls() {
    document.querySelectorAll('input[name="decoration-method"]').forEach((input) => {
      input.addEventListener('change', (e) => {
        state.selectedMethod = e.target.value;
      });
    });
  }

  function sortLocations(locations) {
    return [...(locations || [])].sort((a, b) => {
      const sa = a.sort_order != null ? Number(a.sort_order) : 0;
      const sb = b.sort_order != null ? Number(b.sort_order) : 0;
      return sa - sb;
    });
  }

  function bindFlatPreviewResizeObserver() {
    const frame = document.getElementById('atelier-flat-preview-frame');
    if (!frame || frame.dataset.atelierFlatResizeBound === '1') return;
    frame.dataset.atelierFlatResizeBound = '1';
    const ro = new ResizeObserver(() => {
      window.requestAnimationFrame(() => {
        if (state.currentStep !== 2 || state.mockupPhase !== 'form') return;
        const img = document.getElementById('atelier-flat-preview-img');
        if (!img?.naturalWidth) return;
        paintFlatOverlays();
        renderFlatDragLayer();
      });
    });
    ro.observe(frame);
  }

  function bindMockupStep2() {
    initMockupColors();
    initLogoLibrary();
    initPlacementRows();
    initLogoColorUI();
    bindFlatPreviewResizeObserver();
    initFlatPreviewFaceToggle();
    const genBtn = document.getElementById('atelier-generate-mockups');
    if (genBtn) genBtn.addEventListener('click', () => generateMockupViaRender());
    const viewBtn = document.getElementById('atelier-view-mockups');
    if (viewBtn) {
      viewBtn.addEventListener('click', () => {
        if (!state.mockupPlacements?.length) return;
        renderMockupResults();
        if (3 > state.maxUnlockedStep) state.maxUnlockedStep = 3;
        showStep(3);
      });
    }
    const backEdit = document.getElementById('atelier-mockup-back-edit');
    if (backEdit) backEdit.addEventListener('click', () => showStep(2));

    const skipBtn = document.getElementById('atelier-skip-generation');
    if (skipBtn) skipBtn.addEventListener('click', () => state._mockupAbortController?.abort());
    const resultsInner = document.getElementById('atelier-mockup-results-inner');
    if (resultsInner) {
      resultsInner.addEventListener('click', (e) => {
        const btn = e.target.closest('.mockup-regenerate-btn');
        if (!btn) return;
        const pk = btn.dataset.placement;
        const g = btn.dataset.gender;
        if (pk && g) regenerateMockup(pk, g, btn);
      });
    }
  }

  function initMockupColors() {
    const colorGrid = document.getElementById('atelier-color-grid');
    const nameEl = document.getElementById('selected-color-name');
    if (!colorGrid || !state.productData?.colors?.length) return;

    colorGrid.innerHTML = '';
    state.productData.colors.forEach((color, index) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'color-option' + (index === 0 ? ' is-active' : '');
      btn.dataset.colorHandle = color.handle;
      btn.title = color.label;
      const swatch = document.createElement('div');
      swatch.className = 'color-swatch';
      swatch.style.backgroundColor = normalizeGarmentColorHexFromPayload(color);
      btn.appendChild(swatch);
      btn.addEventListener('click', () => {
        document.querySelectorAll('#atelier-color-grid .color-option').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        state.selectedGarmentColor = color;
        if (nameEl) nameEl.textContent = color.label;
        updateFlatPreview();
      });
      colorGrid.appendChild(btn);
      if (index === 0) {
        state.selectedGarmentColor = color;
        if (nameEl) nameEl.textContent = color.label;
      }
    });
    updateFlatPreview();
  }

  function initLogoLibrary() {
    const inp = document.getElementById('atelier-logo-library-input');
    const addBtn = document.getElementById('atelier-logo-library-add');
    if (!inp || !addBtn) return;
    addBtn.addEventListener('click', () => inp.click());
    inp.addEventListener('change', () => {
      const files = Array.from(inp.files || []);
      files.forEach((file) => {
        if (!file.type.startsWith('image/')) return;
        const reader = new FileReader();
        reader.onload = (e) => {
          const id = 'lib_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
          state.logoLibrary.push({ id, fileName: file.name, dataUrl: e.target.result });
          saveArtworkLibrary();
          renderLogoLibraryList();
          populatePlacementSelects();
          updateGenerateEnabled();
        };
        reader.readAsDataURL(file);
      });
      inp.value = '';
    });
  }

  function renderLogoLibraryList() {
    const list = document.getElementById('atelier-logo-library-list');
    if (!list) return;
    list.innerHTML = '';
    state.logoLibrary.forEach((lib) => {
      const row = document.createElement('div');
      row.className = 'atelier-logo-library-item';
      row.innerHTML = `<img class="atelier-logo-library-thumb" src="${lib.dataUrl}" alt="" width="40" height="40"><span class="atelier-logo-library-name">${lib.fileName}</span><button type="button" class="atelier-logo-library-remove" data-remove="${lib.id}" aria-label="Remove">×</button>`;
      row.querySelector('[data-remove]')?.addEventListener('click', () => {
        state.logoLibrary = state.logoLibrary.filter((x) => x.id !== lib.id);
        saveArtworkLibrary();
        Object.keys(state.placementLogoChoice).forEach((k) => {
          if (state.placementLogoChoice[k] === lib.id) {
            delete state.placementLogoChoice[k];
            delete state.placementLogos[k];
            delete state.logoDragNorm[k];
            delete state.placementLogoScale[k];
          }
        });
        renderLogoLibraryList();
        populatePlacementSelects();
        updateGenerateEnabled();
        renderFlatDragLayer();
      });
      list.appendChild(row);
    });
  }

  function populatePlacementSelects() {
    document.querySelectorAll('.placement-logo-select').forEach((sel) => {
      const key = sel.dataset.key;
      if (!key) return;
      const cur = state.placementLogoChoice[key] || '';
      sel.innerHTML = '<option value="">Select artwork…</option>';
      state.logoLibrary.forEach((lib) => {
        const opt = document.createElement('option');
        opt.value = lib.id;
        opt.textContent = lib.fileName;
        sel.appendChild(opt);
      });
      if (cur && state.logoLibrary.some((x) => x.id === cur)) sel.value = cur;
    });
  }

  function initPlacementRows() {
    const host = document.getElementById('atelier-placement-rows');
    if (!host || !state.productData?.printLocations) return;
    host.innerHTML = '';
    const locs = sortLocations(state.productData.printLocations);
    locs.forEach((loc) => {
      const key = loc.key || loc.handle;
      if (state.placementLogoScale[key] == null) state.placementLogoScale[key] = 1;
      const row = document.createElement('div');
      row.className = 'atelier-placement-row is-collapsed';
      row.dataset.placementKey = key;
      const pv = loc.preview_view || loc.view || 'front';
      row.innerHTML = `
        <div class="atelier-placement-row__main">
          <label class="atelier-placement-check">
            <input type="checkbox" class="atelier-placement-cb" data-key="${key}" data-preview-view="${pv}">
            <span>${loc.label}</span>
          </label>
          <div class="atelier-placement-logo" data-key="${key}">
            <label class="placement-logo-label">Artwork</label>
            <select class="placement-logo-select" data-key="${key}" aria-label="Artwork for ${loc.label}">
              <option value="">Select artwork…</option>
            </select>
          </div>
        </div>
      `;
      host.appendChild(row);

      const cb = row.querySelector('.atelier-placement-cb');
      cb.addEventListener('change', () => {
        row.classList.toggle('is-collapsed', !cb.checked);
        updateGenerateEnabled();
        updateFlatPreview();
      });

      const sel = row.querySelector('.placement-logo-select');
      if (sel) {
        sel.addEventListener('change', () => {
          const id = sel.value;
          state.placementLogoChoice[key] = id;
          const lib = state.logoLibrary.find((x) => x.id === id);
          if (lib) {
            state.placementLogos[key] = { dataUrl: lib.dataUrl, fileName: lib.fileName };
            if (!state.logoDragNorm[key]) state.logoDragNorm[key] = { x: 0.5, y: 0.5 };
            if (cb) { cb.checked = true; row.classList.remove('is-collapsed'); }
          } else {
            delete state.placementLogos[key];
            delete state.logoDragNorm[key];
            delete state.placementLogoScale[key];
          }
          updateGenerateEnabled();
          updateFlatPreview();
        });
      }

    });
    populatePlacementSelects();
    renderLogoLibraryList();
    updateGenerateEnabled();
    updateFlatPreview();
  }

  function initLogoColorUI() {
    const presets = document.getElementById('atelier-logo-color-presets');
    if (presets) {
      presets.innerHTML = '';
      LOGO_PRESETS.forEach((p) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'logo-color-preset';
        b.style.background = p.hex;
        b.title = p.label;
        b.dataset.hex = p.hex;
        b.dataset.label = p.label;
        b.addEventListener('click', () => {
          state.logoColorHex = p.hex;
          state.logoColorLabel = p.label;
          const inp = document.getElementById('atelier-logo-color-input');
          if (inp) inp.value = p.hex;
        });
        presets.appendChild(b);
      });
    }
    document.querySelectorAll('input[name="atelier-logo-color-mode"]').forEach((r) => {
      r.addEventListener('change', () => {
        state.logoColorMode = r.value;
        const custom = document.getElementById('atelier-logo-color-custom');
        if (custom) custom.classList.toggle('hidden', r.value !== 'custom');
        updateGenerateEnabled();
      });
    });
    const colorInp = document.getElementById('atelier-logo-color-input');
    if (colorInp) {
      colorInp.addEventListener('input', () => {
        state.logoColorHex = colorInp.value;
        state.logoColorLabel = colorInp.value.toUpperCase();
      });
    }
  }

  function getPlacementLogoScale(key) {
    const s = state.placementLogoScale[key];
    if (typeof s === 'number' && Number.isFinite(s)) {
      return Math.max(0.35, Math.min(2.5, s));
    }
    return 1;
  }

  function scaleToLogoSizeBucket(scale) {
    const s = typeof scale === 'number' && Number.isFinite(scale) ? scale : 1;
    if (s < 0.82) return 'small';
    if (s > 1.2) return 'large';
    return 'medium';
  }

  /**
   * Which flat image URL and max-rect geometry the studio uses (Front toggle can show side flat if only sleeves are selected).
   */
  function getStudioFlatImageView() {
    if (state.flatPreviewFace === 'back') return 'back';
    const rows = document.querySelectorAll('.atelier-placement-cb:checked');
    let hasFront = false;
    let hasSide = false;
    rows.forEach((cb) => {
      const v = String(cb.dataset.previewView || 'front').toLowerCase();
      if (v === 'front') hasFront = true;
      if (v === 'side') hasSide = true;
    });
    if (hasFront) return 'front';
    if (hasSide) return 'side';
    return 'front';
  }

  /** JSON metafields sometimes arrive as a string; normalize to a plain object. */
  function normalizeColorFlatMap(raw) {
    if (raw == null) return null;
    let cur = raw;
    for (let pass = 0; pass < 3 && typeof cur === 'string'; pass++) {
      const t = cur.trim();
      if (!t) return null;
      try {
        cur = JSON.parse(t);
      } catch {
        return null;
      }
    }
    if (cur != null && typeof cur === 'object' && !Array.isArray(cur)) return cur;
    return null;
  }

  function pickFlatAssetUrl(u) {
    if (typeof u === 'string' && u.trim().length > 0) return u.trim();
    if (u && typeof u === 'object') {
      const x = u.url || u.src || u.href;
      if (typeof x === 'string' && x.trim().length > 0) return x.trim();
    }
    return null;
  }

  /** Align with Liquid `handleize` / geometry app `handleizeColorLabel` (hyphens, case). */
  function handleizeColorLabelForFlatKey(label) {
    const s = String(label || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    return s || 'color';
  }

  /** Align with Liquid `handleize` / app keys (hyphens, case). */
  function normalizeFlatMapKey(h) {
    return String(h || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function lookupColorFlatRow(cmap, key) {
    if (!cmap || key == null || key === '') return null;
    const s = String(key);
    if (cmap[s]) return cmap[s];
    const n = normalizeFlatMapKey(s);
    if (n && cmap[n]) return cmap[n];
    const lower = s.toLowerCase();
    for (const k of Object.keys(cmap)) {
      if (k.toLowerCase() === lower) return cmap[k];
      if (normalizeFlatMapKey(k) === n) return cmap[k];
    }
    return null;
  }

  /** JSON keys may be label-handle OR Shopify metaobject handle — try both from the selected swatch. */
  function findColorFlatRowForSelection(cmap, color) {
    if (!cmap || !color) return null;
    const fromLabel = color.label ? handleizeColorLabelForFlatKey(color.label) : '';
    const tries = [color.handle, color.metaobjectHandle, fromLabel].filter(Boolean);
    const seen = new Set();
    for (const t of tries) {
      if (seen.has(t)) continue;
      seen.add(t);
      const row = lookupColorFlatRow(cmap, t);
      if (row) return row;
    }
    return null;
  }

  /** Pick a usable CDN URL from a per-colour entry for this studio view (with fallbacks). */
  function resolveUrlFromColorFlatEntry(o, view) {
    if (!o || typeof o !== 'object') return null;
    const pick = (k) =>
      pickFlatAssetUrl(o[k]) ||
      pickFlatAssetUrl(o[k.charAt(0).toUpperCase() + k.slice(1)]);
    const front = pick('front');
    const back = pick('back');
    const side = pick('side');
    if (view === 'back') return back || front || side;
    if (view === 'side') return side || front || back;
    return front || back || side;
  }

  function resolveFlatImageUrl(view) {
    const cmap = state.productData?.colorFlatByHandle;
    const color = state.selectedGarmentColor;
    if (cmap && color) {
      const o = findColorFlatRowForSelection(cmap, color);
      const perColor = resolveUrlFromColorFlatEntry(o, view);
      if (perColor) return perColor;
    }
    const flat = state.productData?.previewSet?.flat;
    if (!flat) return null;
    if (view === 'back') return flat.back || flat.front;
    if (view === 'side') return flat.side || flat.front;
    return flat.front || flat.back;
  }

  function studioHasFrontAndBackFlats() {
    return !!(resolveFlatImageUrl('front') && resolveFlatImageUrl('back'));
  }

  function updateFlatPreviewFaceToggleUI() {
    const bar = document.getElementById('atelier-flat-preview-face-toggle');
    if (!bar) return;
    // Show the toggle whenever there is at least a front flat image
    bar.hidden = !resolveFlatImageUrl('front');
    bar.querySelectorAll('[data-flat-face]').forEach((btn) => {
      const face = btn.dataset.flatFace;
      const active = face === state.flatPreviewFace;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      // Disable views that have no flat image available
      btn.disabled = !resolveFlatImageUrl(face);
    });
  }

  function initFlatPreviewFaceToggle() {
    const bar = document.getElementById('atelier-flat-preview-face-toggle');
    if (!bar || bar.dataset.bound === '1') return;
    bar.dataset.bound = '1';
    bar.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-flat-face]');
      if (!btn || btn.disabled) return;
      const face = btn.dataset.flatFace; // 'front', 'back', or 'side'
      if (face === state.flatPreviewFace) return;
      state.flatPreviewFace = face;
      updateFlatPreviewFaceToggleUI();
      updateFlatPreview();
    });
  }

  function mapCheckedPlacementRows() {
    const rows = document.querySelectorAll('.atelier-placement-cb:checked');
    return Array.from(rows).map((cb) => {
      const key = cb.dataset.key;
      const loc = state.productData.printLocations.find((l) => (l.key || l.handle) === key);
      const preview_view = cb.dataset.previewView || loc?.preview_view || loc?.view || 'front';
      return {
        key,
        label: loc?.label || key,
        preview_view,
        logoSize: scaleToLogoSizeBucket(getPlacementLogoScale(key)),
      };
    });
  }

  function getCheckedPlacementsForPreview() {
    const face = state.flatPreviewFace || 'front';
    return mapCheckedPlacementRows().filter((p) => {
      const v = p.preview_view || 'front';
      if (face === 'back') return v === 'back';
      return v === 'front' || v === 'side';
    });
  }

  function normalizePlacementKey(k) {
    return String(k || '')
      .toLowerCase()
      .replace(/-/g, '_');
  }

  function getGuideForPlacement(placement) {
    const pv = placement.preview_view || 'front';
    const nk = normalizePlacementKey(placement.key);
    const maxRect = getMaxRectForView(pv);
    /** Back: single printable zone = full max rect (no upper/mid/full presets). */
    if (pv === 'back') {
      if (maxRect) {
        const layout = getFlatPreviewImageLayout();
        if (layout) {
          const st = image01RectToFramePercentStyle(maxRect, layout);
          if (st) return st;
        }
        return {
          top: `${maxRect.y * 100}%`,
          left: `${maxRect.x * 100}%`,
          width: `${maxRect.w * 100}%`,
          height: `${maxRect.h * 100}%`,
        };
      }
      return PREVIEW_GUIDES.back.garment_back || PREVIEW_GUIDES.back.default;
    }
    const geo = state.productData?.printPreviewGeometry;
    const guides = mergedGeometryGuides(geo);
    let inner = guides[nk];
    if (inner && maxRect) {
      const abs = {
        x: maxRect.x + inner.x * maxRect.w,
        y: maxRect.y + inner.y * maxRect.h,
        w: inner.w * maxRect.w,
        h: inner.h * maxRect.h,
      };
      const layout = getFlatPreviewImageLayout();
      if (layout) {
        const st = image01RectToFramePercentStyle(abs, layout);
        if (st) return st;
      }
      return innerGuideToCssPct(inner, maxRect);
    }
    if (pv === 'side') {
      return PREVIEW_GUIDES.side[nk] || PREVIEW_GUIDES.side.default;
    }
    return PREVIEW_GUIDES.front[nk] || PREVIEW_GUIDES.front.default;
  }

  /** @param {{ top: string, left: string, width: string, height: string }} g */
  function cssGuideToRect01(g) {
    if (!g) return null;
    const parse = (s) => {
      const m = String(s || '').trim().match(/^([\d.]+)%$/);
      return m ? parseFloat(m[1]) / 100 : NaN;
    };
    const x = parse(g.left);
    const y = parse(g.top);
    const w = parse(g.width);
    const h = parse(g.height);
    if ([x, y, w, h].some((n) => Number.isNaN(n) || n <= 0)) return null;
    return { x, y, w, h };
  }

  /** Placement guide in full flat-frame coordinates (0–1). */
  function getPlacementGuideRect01(placement) {
    const pv = placement.preview_view || 'front';
    const nk = normalizePlacementKey(placement.key);
    const maxRect = getMaxRectForView(pv);
    if (pv === 'back' && maxRect) {
      return { x: maxRect.x, y: maxRect.y, w: maxRect.w, h: maxRect.h };
    }
    const geo = state.productData?.printPreviewGeometry;
    const guides = mergedGeometryGuides(geo);
    let inner = guides[nk];
    if (inner && maxRect) {
      if (
        typeof inner.x === 'number' &&
        typeof inner.y === 'number' &&
        typeof inner.w === 'number' &&
        typeof inner.h === 'number'
      ) {
        return {
          x: maxRect.x + inner.x * maxRect.w,
          y: maxRect.y + inner.y * maxRect.h,
          w: inner.w * maxRect.w,
          h: inner.h * maxRect.h,
        };
      }
    }
    return cssGuideToRect01(getGuideForPlacement(placement));
  }

  /**
   * Keeps logo center inside the placement guide (dashed box). `norm` is in the same space as today:
   * within maxRect when maxRect exists (0–1), else full frame 0–1.
   */
  function clampNormToPlacementGuide(placement, norm) {
    if (!norm || typeof norm.x !== 'number' || typeof norm.y !== 'number') return norm;
    const pv = placement.preview_view || 'front';
    const mr = getMaxRectForView(pv);
    const guide = getPlacementGuideRect01(placement);

    let cx;
    let cy;
    if (mr) {
      cx = mr.x + norm.x * mr.w;
      cy = mr.y + norm.y * mr.h;
    } else {
      cx = norm.x;
      cy = norm.y;
    }

    if (guide && guide.w > 0 && guide.h > 0) {
      const insetX = Math.min(guide.w * 0.06, guide.w * 0.5 - 1e-4);
      const insetY = Math.min(guide.h * 0.06, guide.h * 0.5 - 1e-4);
      const minX = guide.x + insetX;
      const maxX = guide.x + guide.w - insetX;
      const minY = guide.y + insetY;
      const maxY = guide.y + guide.h - insetY;
      if (minX <= maxX && minY <= maxY) {
        cx = Math.max(minX, Math.min(maxX, cx));
        cy = Math.max(minY, Math.min(maxY, cy));
      } else {
        cx = guide.x + guide.w / 2;
        cy = guide.y + guide.h / 2;
      }
    }

    if (mr) {
      return {
        x: (cx - mr.x) / mr.w,
        y: (cy - mr.y) / mr.h,
      };
    }
    return { x: cx, y: cy };
  }

  function paintFlatOverlays() {
    const overlays = document.getElementById('atelier-flat-preview-overlays');
    if (!overlays) return;
    overlays.innerHTML = '';
    const view = getStudioFlatImageView();
    const maxRect = getMaxRectForView(view);
    const layout = getFlatPreviewImageLayout();

    if (maxRect) {
      const st = layout
        ? image01RectToFramePercentStyle(maxRect, layout)
        : {
            top: `${maxRect.y * 100}%`,
            left: `${maxRect.x * 100}%`,
            width: `${maxRect.w * 100}%`,
            height: `${maxRect.h * 100}%`,
          };
      if (st) {
        const maxBox = document.createElement('div');
        maxBox.className = 'atelier-flat-preview__max';
        maxBox.style.top = st.top;
        maxBox.style.left = st.left;
        maxBox.style.width = st.width;
        maxBox.style.height = st.height;
        maxBox.title = 'Max print area';
        overlays.appendChild(maxBox);
      }
    }

    getCheckedPlacementsForPreview().forEach((p) => {
      const pv = p.preview_view || 'front';
      // Skip back placements when maxRect is shown (maxRect IS the back guide)
      if (pv === 'back' && maxRect) return;
      // Skip full-garment placements (front/garment_front) when maxRect is shown —
      // the maxRect already represents the full printable area.
      const nk = normalizePlacementKey(p.key);
      if (maxRect && (nk === 'front' || nk === 'garment_front')) return;
      const g = getGuideForPlacement(p);
      const box = document.createElement('div');
      box.className = 'atelier-flat-preview__guide';
      box.style.top = g.top;
      box.style.left = g.left;
      box.style.width = g.width;
      box.style.height = g.height;
      box.title = p.label || p.key;
      overlays.appendChild(box);
    });
  }

  function syncFlatPreviewAfterImageReady() {
    const img = document.getElementById('atelier-flat-preview-img');
    const frame = document.getElementById('atelier-flat-preview-frame');
    if (frame && img?.naturalWidth && img?.naturalHeight) {
      const studio = frame.closest('.atelier-flat-preview--studio');
      if (studio) {
        frame.style.aspectRatio = '';
      } else {
        frame.style.aspectRatio = `${img.naturalWidth} / ${img.naturalHeight}`;
      }
    }
    paintFlatOverlays();
    renderFlatDragLayer();
  }

  function updateFlatPreview() {
    const img = document.getElementById('atelier-flat-preview-img');
    const overlays = document.getElementById('atelier-flat-preview-overlays');
    const wrap = document.getElementById('atelier-flat-preview');
    const frame = document.getElementById('atelier-flat-preview-frame');
    if (!img || !overlays) return;

    const view = getStudioFlatImageView();
    const url = resolveFlatImageUrl(view);
    updateFlatPreviewFaceToggleUI();
    if (url) {
      const onReady = () => syncFlatPreviewAfterImageReady();
      img.onload = onReady;
      img.crossOrigin = 'anonymous';
      img.src = url;
      img.alt = 'Flat garment preview';
      if (wrap) wrap.classList.remove('is-empty');
      if (img.complete && img.naturalWidth) {
        onReady();
      }
    } else {
      img.removeAttribute('src');
      img.alt = '';
      if (wrap) wrap.classList.add('is-empty');
      if (frame) frame.style.aspectRatio = '';
      overlays.innerHTML = '';
      updateFlatPreviewFaceToggleUI();
      renderFlatDragLayer();
    }
  }

  function normToPctInView(placement, norm) {
    const pv = placement.preview_view || 'front';
    const mr = getMaxRectForView(pv);
    if (!mr || !norm) return { left: '50%', top: '50%' };
    const cx = mr.x + norm.x * mr.w;
    const cy = mr.y + norm.y * mr.h;
    const layout = getFlatPreviewImageLayout();
    return image01PointToFramePercent(cx, cy, layout);
  }

  function renderFlatDragLayer() {
    const layer = document.getElementById('atelier-flat-preview-drag-layer');
    if (!layer) return;
    layer.innerHTML = '';
    const checked = getCheckedPlacementsForPreview();
    checked.forEach((p) => {
      const logo = state.placementLogos[p.key];
      if (!logo?.dataUrl) return;
      if (!state.logoDragNorm[p.key]) {
        state.logoDragNorm[p.key] = { x: 0.5, y: 0.5 };
      }
      const prev = state.logoDragNorm[p.key];
      const clamped = clampNormToPlacementGuide(p, prev);
      if (clamped && (Math.abs(clamped.x - prev.x) > 1e-5 || Math.abs(clamped.y - prev.y) > 1e-5)) {
        state.logoDragNorm[p.key] = clamped;
      }
      const pos = normToPctInView(p, state.logoDragNorm[p.key]);
      const scale = getPlacementLogoScale(p.key);

      const g = getGuideForPlacement(p);
      const hit = document.createElement('div');
      hit.className = 'atelier-flat-preview__drag-hit';
      hit.dataset.placementKey = p.key;
      hit.style.top = g.top;
      hit.style.left = g.left;
      hit.style.width = g.width;
      hit.style.height = g.height;
      hit.setAttribute('role', 'presentation');
      hit.addEventListener('pointerdown', onLogoDragStart);
      layer.appendChild(hit);

      const wrap = document.createElement('div');
      wrap.className = 'atelier-flat-preview__drag-wrap';
      wrap.dataset.placementKey = p.key;
      wrap.style.left = pos.left;
      wrap.style.top = pos.top;
      wrap.style.setProperty('--logo-scale', String(scale));
      wrap.addEventListener('pointerdown', onLogoDragStart);

      const el = document.createElement('img');
      el.className = 'atelier-flat-preview__drag-logo';
      el.src = logo.dataUrl;
      el.alt = '';
      el.draggable = false;
      el.dataset.placementKey = p.key;
      wrap.appendChild(el);

      const corners = ['nw', 'ne', 'sw', 'se'];
      corners.forEach((c) => {
        const h = document.createElement('button');
        h.type = 'button';
        h.className = 'atelier-flat-preview__logo-handle atelier-flat-preview__logo-handle--' + c;
        h.dataset.placementKey = p.key;
        h.setAttribute('aria-label', 'Resize logo');
        h.addEventListener('pointerdown', (ev) => onLogoResizeStart(ev, p.key));
        wrap.appendChild(h);
      });

      layer.appendChild(wrap);
    });
  }

  function logoCenterClientPx(placement, frameEl) {
    const fr = frameEl.getBoundingClientRect();
    const pos = normToPctInView(placement, state.logoDragNorm[placement.key]);
    const lx = parseFloat(pos.left) / 100;
    const ly = parseFloat(pos.top) / 100;
    return { cx: fr.left + lx * fr.width, cy: fr.top + ly * fr.height };
  }

  function queryDragWrapForKey(key) {
    const k = String(key || '').replace(/"/g, '');
    return document.querySelector(`.atelier-flat-preview__drag-wrap[data-placement-key="${k}"]`);
  }

  /**
   * Resize must not call renderFlatDragLayer on every move: that destroys the handle node and drops pointer capture.
   * Update --logo-scale on the live wrap during drag; re-render once on pointerup.
   */
  function onLogoResizeStart(e, key) {
    if (e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    const handleEl = e.currentTarget;
    const wrap = handleEl?.closest?.('.atelier-flat-preview__drag-wrap');
    const placement = getCheckedPlacementsForPreview().find((x) => x.key === key);
    if (!wrap || !placement) return;

    const rect0 = wrap.getBoundingClientRect();
    const cx = (rect0.left + rect0.right) / 2;
    const cy = (rect0.top + rect0.bottom) / 2;
    const d0 = Math.hypot(e.clientX - cx, e.clientY - cy);
    const startScale = getPlacementLogoScale(key);
    if (d0 < 4) return;

    const activePointerId = e.pointerId;
    try {
      handleEl.setPointerCapture(activePointerId);
    } catch (_) {}

    const move = (ev) => {
      const d1 = Math.hypot(ev.clientX - cx, ev.clientY - cy);
      const next = Math.max(0.35, Math.min(2.5, startScale * (d1 / d0)));
      state.placementLogoScale[key] = next;
      const live = queryDragWrapForKey(key);
      if (live) live.style.setProperty('--logo-scale', String(next));
    };
    const up = () => {
      document.removeEventListener('pointermove', move);
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      try {
        handleEl.releasePointerCapture(activePointerId);
      } catch (_) {}
      renderFlatDragLayer();
    };
    document.addEventListener('pointermove', move);
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  }

  function onLogoDragStart(e) {
    if (e.button !== 0) return;
    if (e.target.closest('.atelier-flat-preview__logo-handle')) return;
    const target = e.currentTarget.closest('[data-placement-key]') || e.currentTarget;
    const key = target.dataset.placementKey;
    if (!key) return;
    e.preventDefault();
    e.stopPropagation();
    const pointerId = e.pointerId;
    try {
      target.setPointerCapture(pointerId);
    } catch (_) {}
    const frame = document.getElementById('atelier-flat-preview-frame');
    const placement = getCheckedPlacementsForPreview().find((x) => x.key === key);
    if (!frame || !placement) return;
    const pv = placement.preview_view || 'front';
    const mr = getMaxRectForView(pv);

    const move = (ev) => {
      const r = frame.getBoundingClientRect();
      const px = (ev.clientX - r.left) / r.width;
      const py = (ev.clientY - r.top) / r.height;
      const layout = getFlatPreviewImageLayout();
      const { ix, iy } = frame01ToImage01(px, py, layout);
      let nx;
      let ny;
      if (mr) {
        nx = (ix - mr.x) / mr.w;
        ny = (iy - mr.y) / mr.h;
      } else {
        nx = ix;
        ny = iy;
      }
      const raw = { x: nx, y: ny };
      const guided = clampNormToPlacementGuide(placement, raw);
      const out = guided || raw;
      state.logoDragNorm[key] = {
        x: Math.max(0, Math.min(1, out.x)),
        y: Math.max(0, Math.min(1, out.y)),
      };
      renderFlatDragLayer();
    };
    const up = () => {
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', up);
      window.removeEventListener('pointercancel', up);
      try {
        target.releasePointerCapture(pointerId);
      } catch (_) {}
    };
    window.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    window.addEventListener('pointercancel', up);
  }

  function getCheckedPlacements() {
    return mapCheckedPlacementRows();
  }

  function placementLogosComplete() {
    const checked = getCheckedPlacements();
    if (!checked.length) return false;
    return checked.every((p) => !!state.placementLogos[p.key]?.dataUrl);
  }

  function updateGenerateEnabled() {
    const btn = document.getElementById('atelier-generate-mockups');
    if (btn) btn.disabled = !placementLogosComplete();
    // Also sync the footer next button when on step 2
    if (state.currentStep === 2) updateFooterButtons();
  }

  // Resize an image dataUrl to at most maxDim × maxDim before sending to the worker
  function resizeDataUrl(dataUrl, maxDim = 900) {
    return new Promise((resolve) => {
      if (!dataUrl || !dataUrl.startsWith('data:image')) { resolve(dataUrl); return; }
      const img = new Image();
      img.onload = () => {
        const ratio = Math.min(1, maxDim / Math.max(img.width, img.height));
        if (ratio >= 1) { resolve(dataUrl); return; }
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * ratio);
        canvas.height = Math.round(img.height * ratio);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL('image/png', 0.92));
      };
      img.onerror = () => resolve(dataUrl);
      img.src = dataUrl;
    });
  }

  function buildWorkerPayload(options = {}) {
    const placementsOverride = options.placementsOverride;
    const regenerateGender = options.regenerateGender;
    const logosOverride = options.logosOverride || {};
    const cfg = getMockupConfig();
    const placementsRaw = placementsOverride || getCheckedPlacements();
    const placements = placementsRaw.map((p) => {
      const scale = getPlacementLogoScale(p.key);
      // Use pre-resized logo if provided, otherwise fall back to state
      const logoData = logosOverride[p.key] || state.placementLogos[p.key];
      const row = {
        key: p.key,
        label: p.label,
        preview_view: p.preview_view,
        logoSize: p.logoSize || scaleToLogoSizeBucket(scale),
        logoScale: scale,
        logoImageBase64: logoData?.dataUrl,
      };
      const drag = state.logoDragNorm[p.key];
      if (drag && typeof drag.x === 'number' && typeof drag.y === 'number') {
        row.logoPositionNorm = { x: drag.x, y: drag.y };
      }
      return row;
    });
    return {
      sessionId: state.sessionId,
      productHandle: state.productData.product.handle,
      productTitle: state.productData.product.title,
      selectedColor: {
        label: state.selectedGarmentColor.label,
        hex: normalizeGarmentColorHexFromPayload(state.selectedGarmentColor),
        value: normalizeGarmentColorHexFromPayload(state.selectedGarmentColor),
      },
      printMethod: getPrintMethodForWorker(),
      placements,
      previewSet: state.productData.previewSet,
      gender: (state.productData.gender || 'unisex').toLowerCase(),
      logoColor:
        state.logoColorMode === 'custom'
          ? { label: state.logoColorLabel, hex: normalizeHex(state.logoColorHex) }
          : null,
      watermarkImageUrl: cfg.watermarkImageUrl || undefined,
      ...(regenerateGender ? { regenerateGender } : {}),
    };
  }

  function mergePlacementResults(incoming) {
    const map = new Map();
    (state.mockupPlacements || []).forEach((x) => {
      map.set(`${x.placementKey}|${x.gender}`, x);
    });
    (incoming || []).forEach((x) => {
      map.set(`${x.placementKey}|${x.gender}`, x);
    });
    state.mockupPlacements = Array.from(map.values());
  }

  // ─── Deterministic render helpers (A5 / A6) ──────────────────────────────
  //
  // These replace the Gemini /generate call with the Cloudflare Worker's
  // /render-mockup endpoint, which does a pure-JS homography + cylinder warp.
  // No AI involved — the calibration data baked in via the admin tool drives it.

  /**
   * Convert a logo's placement in the storefront (maxRect-relative) to the
   * uniform-normalized coordinate space expected by the Worker's /render-mockup.
   *
   * @param {object} placement  - A checked placement object (key, preview_view, …)
   * @param {string} view       - 'front' | 'back' | 'side'
   * @param {object} cal        - Calibration entry for this view from mockupCalibration[view]
   * @param {{w:number,h:number}} flatDims - Natural pixel dimensions of the flat image
   * @returns {{ flatCorners, modelCorners, logoOnFlat, surfaceType, wrapAngle } | null}
   */
  function buildRenderPayload(placement, view, cal, flatDims) {
    if (!cal || !cal.flatCorners || !cal.modelCorners) return null;
    if (!flatDims || !flatDims.w || !flatDims.h) return null;

    // Calibration stores corners as uniform-normalized (both axes / imageWidth).
    // The server expects the same format — pass them through as-is.
    const flatCorners  = cal.flatCorners;   // [[x,y],…] × 4
    const modelCorners = cal.modelCorners;  // [[x,y],…] × 4

    // Compute the print-area bounding box in uniform-normalized coords.
    const paxs = flatCorners.map(c => c[0]);
    const pays = flatCorners.map(c => c[1]);
    const paX  = Math.min(...paxs);
    const paY  = Math.min(...pays);
    const paW  = Math.max(...paxs) - paX;
    const paH  = Math.max(...pays) - paY;

    // logoDragNorm is the logo centre within the print-area box (0–1 each axis).
    const drag  = state.logoDragNorm[placement.key] || { x: 0.5, y: 0.5 };
    const scale = getPlacementLogoScale(placement.key);

    // Default logo occupies ~40 % of the shorter print-area axis at scale=1.
    const defaultLogoFrac = 0.4 * scale;  // fraction of paW / paH independently

    // Logo center in uniform-normalized space
    const lcx = paX + drag.x * paW;
    const lcy = paY + drag.y * paH;

    // Logo size in uniform-normalized space (preserves aspect ratio via uniform space)
    const logoLW = paW * defaultLogoFrac;
    const logoLH = paH * defaultLogoFrac;

    const logoOnFlat = {
      x: lcx - logoLW / 2,
      y: lcy - logoLH / 2,
      w: logoLW,
      h: logoLH,
    };

    return {
      flatCorners,
      modelCorners,
      logoOnFlat,
      surfaceType: cal.surfaceType || 'flat',
      wrapAngle:   cal.wrapAngle   ?? 90,
    };
  }

  /**
   * Render mockups via the Worker's deterministic /render-mockup endpoint.
   * Falls through to generateMockups (AI path) if calibration data is missing.
   */
  async function generateMockupViaRender(options = {}) {
    const cfg = getMockupConfig();
    if (!cfg.workerUrl) {
      setStep2Validation('Configure Mockup Worker URL in the theme editor.');
      return;
    }

    const pd          = state.productData;
    const calibration = pd?.mockupCalibration;

    // If no calibration data at all, fall back to AI generation
    if (!calibration) {
      console.info('[atelier] No mockupCalibration — falling back to AI /generate');
      return generateMockups(options);
    }

    const isPartial = !!options.regenerateGender && options.placementsOverride?.length === 1;
    if (isPartial) {
      const pl = options.placementsOverride[0];
      if (!state.placementLogos[pl.key]?.dataUrl) {
        setStep2Validation('Upload a logo for this placement first.');
        return;
      }
    } else {
      if (!placementLogosComplete()) {
        setStep2Validation('Upload a logo for each selected print location.');
        return;
      }
      const placements = getCheckedPlacements();
      if (placements.length === 0) {
        setStep2Validation('Select at least one print location.');
        return;
      }
    }
    if (!state.selectedGarmentColor) {
      setStep2Validation('Select a garment colour.');
      return;
    }

    setStep2Validation('');

    if (!options.placementsOverride) {
      const locs = getCheckedPlacements();
      state.selectedLocations = locs.map((p) => p.key);
      state.selectedColor =
        state.selectedGarmentColor?.label || state.selectedGarmentColor?.handle || 'Colour';
      const instr = document.querySelector('[data-special-instructions]');
      if (instr) state.specialInstructions = instr.value;
    }

    const formLoading = document.getElementById('atelier-mockup-form-loading');
    const genOverlay  = document.getElementById('atelier-mockup-generating-overlay');
    const genBtn      = document.getElementById('atelier-generate-mockups');
    if (formLoading) formLoading.classList.remove('hidden');
    if (genOverlay)  genOverlay.classList.remove('hidden');
    if (genBtn)      genBtn.disabled = true;

    const placements = options.placementsOverride || getCheckedPlacements();
    const genders    = state.productData?.gender === 'female'
      ? ['female']
      : state.productData?.gender === 'male'
        ? ['male']
        : ['male', 'female'];
    const targetGenders = options.regenerateGender ? [options.regenerateGender] : genders;

    const renderBase = cfg.workerUrl.replace(/\/$/, '') + '/render-mockup';

    // Build tasks: one per (placement × gender)
    const tasks = [];
    for (const placement of placements) {
      const view = (placement.preview_view || 'front').toLowerCase();
      const cal  = calibration[view];

      if (!cal) {
        // No calibration for this view — fall back to AI for this placement only
        console.warn(`[atelier] No calibration for view "${view}", skipping deterministic render`);
        continue;
      }

      const flatDims = pd.flatImageDimensions?.[view];
      const payload  = buildRenderPayload(placement, view, cal, flatDims);
      if (!payload) continue;

      const logoData = state.placementLogos[placement.key];
      if (!logoData?.dataUrl) continue;

      for (const gender of targetGenders) {
        const modelImageUrl =
          gender === 'female'
            ? pd.previewSet?.model?.female?.[view]
            : pd.previewSet?.model?.male?.[view];

        if (!modelImageUrl) continue;

        tasks.push({ placement, gender, view, modelImageUrl, logoDataUrl: logoData.dataUrl, payload });
      }
    }

    if (tasks.length === 0) {
      // Nothing could be rendered deterministically — fall back to AI
      console.info('[atelier] No renderable tasks found — falling back to AI /generate');
      if (formLoading) formLoading.classList.add('hidden');
      if (genOverlay)  genOverlay.classList.add('hidden');
      if (genBtn)      genBtn.disabled = false;
      return generateMockups(options);
    }

    try {
      const results = await Promise.allSettled(
        tasks.map(async (t) => {
          const body = {
            modelImageUrl: t.modelImageUrl,
            logoDataUrl:   t.logoDataUrl,
            flatCorners:   t.payload.flatCorners,
            modelCorners:  t.payload.modelCorners,
            logoOnFlat:    t.payload.logoOnFlat,
            surfaceType:   t.payload.surfaceType,
            wrapAngle:     t.payload.wrapAngle,
          };
          const res  = await fetch(renderBase, {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify(body),
          });
          const data = await res.json();
          if (!res.ok || data.error) throw new Error(data.error || 'Render failed');
          return {
            placementKey: t.placement.key,
            label:        t.placement.label,
            view:         t.view,
            gender:       t.gender,
            imageDataUrl: data.resultDataUrl,
          };
        })
      );

      const incoming = [];
      const errors   = [];
      results.forEach((r, i) => {
        if (r.status === 'fulfilled') {
          incoming.push(r.value);
        } else {
          errors.push({ placementKey: tasks[i].placement.key, gender: tasks[i].gender, error: r.reason?.message });
        }
      });

      if (options.regenerateGender) {
        mergePlacementResults(incoming);
      } else {
        state.mockupPlacements = incoming;
      }
      state.mockupErrors = errors;
      state.mockupReady  = true;
      renderMockupResults();
      if (3 > state.maxUnlockedStep) state.maxUnlockedStep = 3;
      showStep(3);
    } catch (err) {
      console.error('[atelier] render-mockup error', err);
      setStep2Validation(err.message || 'Could not render mockups. Try again.');
    } finally {
      if (formLoading) formLoading.classList.add('hidden');
      if (genOverlay)  genOverlay.classList.add('hidden');
      if (genBtn)      genBtn.disabled = false;
      updateGenerateEnabled();
      updateFooterButtons();
    }
  }

  async function generateMockups(options = {}) {
    const cfg = getMockupConfig();
    if (!cfg.workerUrl) {
      setStep2Validation('Configure Mockup Worker URL in the theme editor (section settings).');
      return;
    }
    const isPartial = !!options.regenerateGender && options.placementsOverride?.length === 1;
    if (isPartial) {
      const pl = options.placementsOverride[0];
      if (!state.placementLogos[pl.key]?.dataUrl) {
        setStep2Validation('Upload a logo for this placement first.');
        return;
      }
    } else {
      if (!placementLogosComplete()) {
        setStep2Validation('Upload a logo for each selected print location.');
        return;
      }
      const placements = getCheckedPlacements();
      if (placements.length === 0) {
        setStep2Validation('Select at least one print location.');
        return;
      }
    }
    if (!state.selectedGarmentColor) {
      setStep2Validation('Select a garment colour.');
      return;
    }

    setStep2Validation('');

    // Ensure selectedLocations is always up to date (may be called without validateCurrentStep)
    if (!options.placementsOverride) {
      const locs = getCheckedPlacements();
      state.selectedLocations = locs.map((p) => p.key);
      state.selectedColor =
        state.selectedGarmentColor?.label || state.selectedGarmentColor?.handle || 'Colour';
      const instr = document.querySelector('[data-special-instructions]');
      if (instr) state.specialInstructions = instr.value;
    }

    const formLoading = document.getElementById('atelier-mockup-form-loading');
    const genOverlay = document.getElementById('atelier-mockup-generating-overlay');
    const genBtn = document.getElementById('atelier-generate-mockups');
    if (formLoading) formLoading.classList.remove('hidden');
    if (genOverlay) genOverlay.classList.remove('hidden');
    if (genBtn) genBtn.disabled = true;

    // Pre-resize all logo images to reduce payload size and speed up generation
    const logosOverride = {};
    await Promise.all(
      Object.keys(state.placementLogos).map(async (key) => {
        const src = state.placementLogos[key]?.dataUrl;
        logosOverride[key] = { ...state.placementLogos[key], dataUrl: src ? await resizeDataUrl(src, 900) : src };
      })
    );

    const body = buildWorkerPayload({ ...options, logosOverride });
    const url = cfg.workerUrl.replace(/\/$/, '') + '/generate';

    // Store abort controller so skip button can cancel
    const controller = new AbortController();
    state._mockupAbortController = controller;

    try {
      const tid = setTimeout(() => controller.abort(), 120000);
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: controller.signal,
      });
      clearTimeout(tid);
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data.error || data.message || 'Generation failed');
      }
      const incoming = data.placements || [];
      if (options?.regenerateGender) {
        mergePlacementResults(incoming);
      } else {
        state.mockupPlacements = incoming;
      }
      state.mockupErrors = data.errors || [];
      state.mockupReady = true;
      renderMockupResults();
      if (3 > state.maxUnlockedStep) state.maxUnlockedStep = 3;
      showStep(3);
    } catch (err) {
      if (err.name === 'AbortError') {
        // User skipped — navigate to step 3 with whatever we have (may be empty)
        state.mockupReady = true;
        if (3 > state.maxUnlockedStep) state.maxUnlockedStep = 3;
        renderMockupResults();
        showStep(3);
        // Show a skip notice on the preview screen
        const skipNote = document.getElementById('atelier-preview-skip-note');
        if (skipNote) skipNote.classList.remove('hidden');
      } else {
        console.error(err);
        setStep2Validation(err.message || 'Could not generate mockups. Try again.');
      }
    } finally {
      state._mockupAbortController = null;
      if (formLoading) formLoading.classList.add('hidden');
      if (genOverlay) genOverlay.classList.remove('hidden');
      if (genOverlay) genOverlay.classList.add('hidden');
      if (genBtn) genBtn.disabled = false;
      updateGenerateEnabled();
      updateFooterButtons();
    }
  }

  async function regenerateMockup(placementKey, gender, btnEl) {
    const cfg = getMockupConfig();
    if (!cfg.workerUrl) return;
    const p = getCheckedPlacements().find((x) => x.key === placementKey);
    if (!p || !state.placementLogos[placementKey]?.dataUrl) {
      alert('Keep this location selected with a logo uploaded to regenerate.');
      return;
    }
    const prev = btnEl?.textContent;
    if (btnEl) {
      btnEl.disabled = true;
      btnEl.textContent = '…';
    }
    try {
      await generateMockupViaRender({ placementsOverride: [p], regenerateGender: gender });
    } finally {
      if (btnEl) {
        btnEl.disabled = false;
        btnEl.textContent = prev || 'Regenerate';
      }
    }
  }

  function normalizeHex(h) {
    if (!h) return '#FFFFFF';
    let s = String(h).trim();
    if (!s.startsWith('#')) s = '#' + s;
    return s;
  }

  function rgbComponentsToHex(r, g, b) {
    const clamp = (n) => Math.max(0, Math.min(255, Math.round(Number(n))));
    const to = (n) => clamp(n).toString(16).padStart(2, '0');
    return `#${to(r)}${to(g)}${to(b)}`;
  }

  /** Shopify color JSON uses hue (0–360), saturation/lightness (0–100). */
  function hslToHex(h, s, l) {
    const hh = ((Number(h) % 360) + 360) % 360;
    const ss = Math.max(0, Math.min(100, Number(s))) / 100;
    const ll = Math.max(0, Math.min(100, Number(l))) / 100;
    if (ss === 0) {
      const v = rgbComponentsToHex(ll * 255, ll * 255, ll * 255);
      return v;
    }
    const hue2rgb = (p, q, t) => {
      let tt = t;
      if (tt < 0) tt += 1;
      if (tt > 1) tt -= 1;
      if (tt < 1 / 6) return p + (q - p) * 6 * tt;
      if (tt < 1 / 2) return q;
      if (tt < 2 / 3) return p + (q - p) * (2 / 3 - tt) * 6;
      return p;
    };
    const q = ll < 0.5 ? ll * (1 + ss) : ll + ss - ll * ss;
    const p = 2 * ll - q;
    const hr = hh / 360;
    const r = hue2rgb(p, q, hr + 1 / 3);
    const g = hue2rgb(p, q, hr);
    const b = hue2rgb(p, q, hr - 1 / 3);
    return rgbComponentsToHex(r * 255, g * 255, b * 255);
  }

  /**
   * `| json` on Shopify color fields yields objects with red/green/blue, rgb string, or hue/saturation/lightness — not `hex`.
   * Liquid also sends `cssHex` (color | append: '') as a plain # string when supported.
   */
  function hexFromShopifyColorRaw(raw) {
    if (raw == null || raw === '') return null;
    if (typeof raw === 'object') {
      if (typeof raw.hex === 'string') return hexFromShopifyColorRaw(raw.hex);
      if (typeof raw.value === 'string') return hexFromShopifyColorRaw(raw.value);
      const r = raw.red;
      const g = raw.green;
      const b = raw.blue;
      if (typeof r === 'number' && typeof g === 'number' && typeof b === 'number') {
        return rgbComponentsToHex(r, g, b);
      }
      if (typeof raw.rgb === 'string') {
        const parts = raw.rgb.trim().split(/\s+/).map((x) => parseFloat(x));
        if (parts.length >= 3 && parts.every((n) => Number.isFinite(n))) {
          return rgbComponentsToHex(parts[0], parts[1], parts[2]);
        }
      }
      if (
        typeof raw.hue === 'number' &&
        typeof raw.saturation === 'number' &&
        typeof raw.lightness === 'number'
      ) {
        return hslToHex(raw.hue, raw.saturation, raw.lightness);
      }
      return null;
    }
    const s = String(raw).trim();
    if (!s) return null;
    if (s.startsWith('{')) {
      try {
        const o = JSON.parse(s);
        return hexFromShopifyColorRaw(o.hex ?? o.value ?? o);
      } catch {
        return null;
      }
    }
    return normalizeHex(s.replace(/^#/, ''));
  }

  function normalizeGarmentColorHexFromPayload(color) {
    if (!color) return '#888888';
    const tries = [color.cssHex, color.hex, color.value];
    for (const raw of tries) {
      const h = hexFromShopifyColorRaw(raw);
      if (h && /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/.test(h)) return h;
    }
    return '#888888';
  }

  function getPrintMethodForWorker() {
    const methods = state.productData.printMethods || [];
    const m = methods.find((x) => x.label.toLowerCase() === String(state.selectedMethod).toLowerCase());
    return {
      key: m?.key || String(state.selectedMethod).toLowerCase().replace(/\s+/g, '-'),
      label: m?.label || state.selectedMethod,
    };
  }

  function showMockupForm() {
    state.mockupPhase = 'form';
    const form = document.getElementById('atelier-mockup-form');
    const res = document.getElementById('atelier-mockup-results');
    if (form) form.classList.remove('hidden');
    if (res) res.classList.add('hidden');
    updateFooterButtons();
    syncMockupStudioLayoutClass();
  }

  function showMockupResults() {
    state.mockupPhase = 'results';
    const form = document.getElementById('atelier-mockup-form');
    const res = document.getElementById('atelier-mockup-results');
    if (form) form.classList.add('hidden');
    if (res) res.classList.remove('hidden');
    updateFooterButtons();
    syncMockupStudioLayoutClass();
  }

  function renderMockupResults() {
    /* --- Build flat list of all mockup images (male + female, all placements) --- */
    const allImages = [];
    const byPlacement = {};
    state.mockupPlacements.forEach((p) => {
      if (!byPlacement[p.placementKey]) byPlacement[p.placementKey] = [];
      byPlacement[p.placementKey].push(p);
    });

    Object.keys(byPlacement).forEach((pkey) => {
      const items = byPlacement[pkey];
      const loc = state.productData.printLocations.find((l) => (l.key || l.handle) === pkey);
      const label = loc?.label || pkey;
      items.forEach((item) => {
        if (item.imageUrl) {
          const genderLabel = item.gender === 'female' ? 'Female' : 'Male';
          allImages.push({
            url: item.imageUrl,
            label: `${label} — ${genderLabel}`,
            placementKey: pkey,
            gender: item.gender,
          });
        }
      });
    });

    /* --- Main preview image --- */
    const mainImg = document.getElementById('atelier-mockup-gallery-main-img');
    const thumbsContainer = document.getElementById('atelier-mockup-gallery-thumbs');
    const downloadBtn = document.getElementById('atelier-mockup-gallery-download');
    if (!mainImg || !thumbsContainer) return;

    thumbsContainer.innerHTML = '';

    if (allImages.length === 0) {
      mainImg.src = '';
      mainImg.alt = 'No mockups generated';
      return;
    }

    /* Set first image as active */
    mainImg.src = allImages[0].url;
    mainImg.alt = allImages[0].label;
    state._galleryActiveUrl = allImages[0].url;
    state._galleryActiveLabel = allImages[0].label;

    /* --- Build thumbnails --- */
    allImages.forEach((img, idx) => {
      const thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'atelier-mockup-thumb' + (idx === 0 ? ' is-active' : '');
      thumb.title = img.label;
      thumb.innerHTML = `
        <img src="${img.url}" alt="${img.label}" class="atelier-mockup-thumb__img" loading="lazy">
        <span class="atelier-mockup-thumb__label">${img.label}</span>
      `;
      thumb.addEventListener('click', () => {
        mainImg.src = img.url;
        mainImg.alt = img.label;
        state._galleryActiveUrl = img.url;
        state._galleryActiveLabel = img.label;
        thumbsContainer.querySelectorAll('.atelier-mockup-thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
      thumbsContainer.appendChild(thumb);
    });

    /* --- Download button --- */
    if (downloadBtn) {
      const newBtn = downloadBtn.cloneNode(true);
      downloadBtn.parentNode.replaceChild(newBtn, downloadBtn);
      newBtn.addEventListener('click', () => {
        downloadMockupCard(state._galleryActiveUrl, state._galleryActiveLabel || 'mockup');
      });
    }

    /* --- Errors --- */
    const inner = document.getElementById('atelier-mockup-results-inner');
    if (inner) inner.innerHTML = '';
    if (state.mockupErrors?.length && inner) {
      inner.classList.remove('hidden');
      const err = document.createElement('div');
      err.className = 'atelier-mockup-errors';
      err.innerHTML =
        '<strong>Some previews failed:</strong> ' +
        state.mockupErrors.map((e) => `${e.placementKey} (${e.gender}): ${e.error}`).join('; ');
      inner.appendChild(err);
    }
  }

  function downloadMockupCard(imageUrl, placementLabel) {
    const cfg = getMockupConfig();
    const wrap = document.createElement('div');
    wrap.style.position = 'fixed';
    wrap.style.left = '-9999px';
    wrap.style.padding = '24px';
    wrap.style.background = '#fff';
    wrap.style.fontFamily = 'system-ui, sans-serif';
    wrap.style.width = '420px';
    wrap.innerHTML = `
      <div style="font-weight:700;font-size:18px;margin-bottom:12px;">${cfg.brandLabel || 'Atelier Finery'}</div>
      <img id="dl-mock" crossorigin="anonymous" style="width:100%;height:auto;display:block;margin-bottom:12px;" alt="">
      <div style="font-size:16px;">${state.productData.product.title} — ${state.selectedGarmentColor?.label || ''}</div>
      <div style="font-size:14px;color:#444;margin-top:4px;">${state.selectedMethod} · ${placementLabel}</div>
      <div style="font-size:13px;color:#888;margin-top:12px;">${cfg.storeDomain || ''}</div>
    `;
    document.body.appendChild(wrap);
    const im = wrap.querySelector('#dl-mock');
    im.onload = () => {
      if (typeof html2canvas !== 'function') {
        document.body.removeChild(wrap);
        window.open(imageUrl, '_blank');
        return;
      }
      html2canvas(wrap, { scale: 2, useCORS: true })
        .then((canvas) => {
          canvas.toBlob((blob) => {
            const a = document.createElement('a');
            a.href = URL.createObjectURL(blob);
            a.download = `mockup-${placementLabel.replace(/\s+/g, '-')}.png`;
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(wrap);
          });
        })
        .catch(() => {
          document.body.removeChild(wrap);
          window.open(imageUrl, '_blank');
        });
    };
    im.onerror = () => {
      document.body.removeChild(wrap);
      window.open(imageUrl, '_blank');
    };
    im.src = imageUrl;
  }

  function populateSizeTable() {
    const tableBody = document.getElementById('atelier-size-table-body');
    if (!tableBody) return;
    let sizes = state.productData?.sizes || [];
    if (sizes.length === 0) {
      sizes = [
        { label: 'XS', value: 'xs' },
        { label: 'S', value: 's' },
        { label: 'M', value: 'm' },
        { label: 'L', value: 'l' },
        { label: 'XL', value: 'xl' },
        { label: '2XL', value: '2xl' },
        { label: '3XL', value: '3xl' },
      ];
    }
    tableBody.innerHTML = '';
    sizes.forEach((size) => {
      const sizeLabel = size.label || size;
      const sizeValue = size.value || size.label || size;
      const isExtended = CONFIG.extendedSizes.some((ext) => sizeLabel.toUpperCase().includes(ext));
      const card = document.createElement('div');
      card.className = 'fs-size-card';
      card.dataset.sizeCard = sizeValue;
      card.innerHTML = `
        <div class="fs-size-card__header">
          <div class="fs-size-card__label">${sizeLabel}</div>
          ${isExtended
            ? `<span class="fs-size-card__surcharge">+CA$${CONFIG.extendedSizeSurcharge}</span>`
            : `<span class="fs-size-card__status">Standard</span>`}
        </div>
        <div class="fs-size-card__stepper">
          <button type="button" class="fs-size-card__stepper-btn" data-stepper-dec="${sizeValue}" aria-label="Decrease ${sizeLabel}">−</button>
          <input type="number" class="fs-size-card__stepper-input size-breakdown-input" data-size="${sizeValue}" min="0" value="${state.sizeBreakdown[sizeValue] || 0}" inputmode="numeric" pattern="[0-9]*" aria-label="${sizeLabel} quantity">
          <button type="button" class="fs-size-card__stepper-btn" data-stepper-inc="${sizeValue}" aria-label="Increase ${sizeLabel}">+</button>
        </div>
        <div class="fs-size-card__footer">
          <span class="fs-size-card__size-name">${sizeLabel}</span>
        </div>
      `;
      tableBody.appendChild(card);
      // Restore visual active state if quantity persisted
      if ((state.sizeBreakdown[sizeValue] || 0) > 0) card.classList.add('is-active');
    });

    // Bind stepper buttons for +/- controls
    tableBody.querySelectorAll('[data-stepper-inc]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sz = btn.dataset.stepperInc;
        const inp = tableBody.querySelector(`.size-breakdown-input[data-size="${sz}"]`);
        if (inp) { inp.value = (parseInt(inp.value, 10) || 0) + 1; updateSizeBreakdown(); updateSizeCardState(sz, tableBody); }
      });
    });
    tableBody.querySelectorAll('[data-stepper-dec]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const sz = btn.dataset.stepperDec;
        const inp = tableBody.querySelector(`.size-breakdown-input[data-size="${sz}"]`);
        if (inp) { inp.value = Math.max(0, (parseInt(inp.value, 10) || 0) - 1); updateSizeBreakdown(); updateSizeCardState(sz, tableBody); }
      });
    });

    bindStep3Controls();
  }

  function initializeSizeBreakdown() {
    populateSizeTable();
    document.querySelectorAll('.size-breakdown-input').forEach((input) => {
      input.addEventListener('input', updateSizeBreakdown);
    });
    updateSizeBreakdown();
  }

  function bindStep3Controls() {
    document.querySelectorAll('.size-breakdown-input').forEach((input) => {
      input.addEventListener('input', () => {
        updateSizeBreakdown();
        updateSizeCardState(input.dataset.size);
      });
    });
  }

  function updateSizeCardState(sizeValue, container) {
    const tableBody = container || document.getElementById('atelier-size-table-body');
    if (!tableBody) return;
    const card = tableBody.querySelector(`[data-size-card="${sizeValue}"]`);
    if (!card) return;
    const inp = card.querySelector(`.size-breakdown-input[data-size="${sizeValue}"]`);
    const qty = inp ? (parseInt(inp.value, 10) || 0) : 0;
    card.classList.toggle('is-active', qty > 0);
    const statusEl = card.querySelector('.fs-size-card__status');
    if (statusEl) statusEl.textContent = qty > 0 ? `${qty} units` : 'Standard';
  }

  function updateSizeBreakdown() {
    state.sizeBreakdown = {};
    state.extendedSizeCount = 0;
    const tableBody = document.getElementById('atelier-size-table-body');
    document.querySelectorAll('.size-breakdown-input').forEach((input) => {
      const size = input.dataset.size;
      const qty = parseInt(input.value, 10) || 0;
      if (qty > 0) {
        state.sizeBreakdown[size] = qty;
        if (CONFIG.extendedSizes.some((extSize) => size.includes(extSize))) {
          state.extendedSizeCount += qty;
        }
      }
      updateSizeCardState(size, tableBody);
    });
    state.totalQuantity = calculateTotalQuantity();
    const totalQtyEl = document.getElementById('atelier-total-qty');
    if (totalQtyEl) totalQtyEl.textContent = state.totalQuantity;

    // Update volume bar fill
    const fillEl = document.getElementById('fs-volume-fill');
    if (fillEl) {
      const pct = Math.min(100, (state.totalQuantity / 50) * 100);
      fillEl.style.width = `${pct}%`;
    }

    updateValidationFeedback();
    updateTierIncentive();
    updateFooterPriceDisplay();
  }

  function calculateTotalQuantity() {
    return Object.values(state.sizeBreakdown).reduce((sum, qty) => sum + qty, 0);
  }

  function updateValidationFeedback() {
    const validationEl = document.getElementById('atelier-validation');
    if (!validationEl) return;
    const totalQty = state.totalQuantity;
    if (totalQty === 0) {
      validationEl.classList.add('hidden');
      return;
    }
    validationEl.classList.remove('hidden');
    if (totalQty < CONFIG.minimumOrder) {
      validationEl.className = 'size-validation is-error';
      validationEl.textContent = `Need ${CONFIG.minimumOrder - totalQty} more units to meet minimum order (12 units)`;
    } else if (
      state.selectedMethod &&
      String(state.selectedMethod).toLowerCase().includes('screen') &&
      totalQty < CONFIG.screenPrintMinimum
    ) {
      validationEl.className = 'size-validation is-error';
      validationEl.textContent = `Screen printing requires ${CONFIG.screenPrintMinimum - totalQty} more units (24 minimum)`;
    } else {
      validationEl.className = 'size-validation is-ok';
      validationEl.textContent = `✓ ${totalQty} units ready to order`;
    }
  }

  function updateTierIncentive() {
    const incentiveEl = document.getElementById('atelier-tier-incentive');
    if (!incentiveEl) return;
    const totalQty = state.totalQuantity;
    const tiers = [
      { min: 24, discount: '11%' },
      { min: 48, discount: '22%' },
      { min: 72, discount: '28%' },
      { min: 100, discount: '33%' },
      { min: 200, discount: '40%' },
    ];
    const nextTier = tiers.find((t) => t.min > totalQty);
    if (nextTier && totalQty >= CONFIG.minimumOrder) {
      incentiveEl.classList.remove('hidden');
      incentiveEl.innerHTML = `Add ${nextTier.min - totalQty} more units to unlock ${nextTier.discount} discount (applied automatically at checkout)!`;
    } else {
      incentiveEl.classList.add('hidden');
    }
  }

  function bindStep4Controls() {
    const checkoutBtn = document.getElementById('atelier-checkout');
    const quoteBtn = document.getElementById('atelier-request-quote');
    if (checkoutBtn) checkoutBtn.addEventListener('click', proceedToCheckout);
    if (quoteBtn) quoteBtn.addEventListener('click', requestQuote);
  }

  function renderSummary() {
    const pricing = calculateEstimatedPricing();
    const pricePerUnitEl = document.getElementById('atelier-price-per-unit');
    if (pricePerUnitEl) pricePerUnitEl.textContent = `CA$${pricing.pricePerUnit.toFixed(2)}`;
    const qtyLabelEl = document.getElementById('atelier-qty-label');
    if (qtyLabelEl) qtyLabelEl.textContent = `${state.totalQuantity} units`;
    const totalEl = document.getElementById('atelier-price-total');
    if (totalEl) totalEl.textContent = `CA$${pricing.subtotal.toFixed(2)}`;
    const discountBadge = document.getElementById('atelier-discount-badge');
    if (discountBadge) discountBadge.classList.add('hidden');
    const savingsRow = document.getElementById('atelier-savings-row');
    if (savingsRow) savingsRow.style.display = 'none';
    const addSection = document.getElementById('atelier-add-section');
    const quoteSection = document.getElementById('atelier-quote-section');
    if (state.totalQuantity > CONFIG.quoteThreshold) {
      if (addSection) addSection.classList.add('hidden');
      if (quoteSection) quoteSection.classList.remove('hidden');
    } else {
      if (addSection) addSection.classList.remove('hidden');
      if (quoteSection) quoteSection.classList.add('hidden');
    }

    // Populate new summary UI elements
    const colorDisplayEl = document.getElementById('summary-color-display');
    if (colorDisplayEl) {
      colorDisplayEl.textContent = `Colour: ${state.selectedGarmentColor?.label || state.selectedColor || '—'}`;
    }

    const methodDisplayEl = document.getElementById('summary-method-display');
    if (methodDisplayEl && state.selectedMethod) {
      const nameEl = methodDisplayEl.querySelector('.fs-print-method-name');
      if (nameEl) nameEl.textContent = state.selectedMethod;
      const subEl = methodDisplayEl.querySelector('.fs-print-method-sub');
      if (subEl) subEl.textContent = `CA$${pricing.basePrice.toFixed(2)} / unit`;
    }

    const totalUnitsEl = document.getElementById('summary-total-units');
    if (totalUnitsEl) totalUnitsEl.textContent = state.totalQuantity;

    const garmentCostEl = document.getElementById('summary-garment-cost');
    if (garmentCostEl) garmentCostEl.textContent = `CA$${(pricing.pricePerUnit * state.totalQuantity).toFixed(2)}`;

    const sizeChipsEl = document.getElementById('summary-size-chips');
    if (sizeChipsEl) {
      sizeChipsEl.innerHTML = '';
      Object.entries(state.sizeBreakdown).forEach(([size, qty]) => {
        const chip = document.createElement('div');
        chip.className = 'fs-size-chip';
        chip.innerHTML = `<div class="fs-size-chip__size">${size.toUpperCase()}</div><div class="fs-size-chip__qty">${qty}</div>`;
        sizeChipsEl.appendChild(chip);
      });
    }

    const placementsEl = document.getElementById('summary-placements-display');
    if (placementsEl) {
      placementsEl.innerHTML = '';
      const locs = state.productData?.printLocations || [];
      state.selectedLocations.forEach((key) => {
        const loc = locs.find((l) => (l.key || l.handle) === key);
        const label = loc?.label || key;
        const logo = state.placementLogos[key];
        // Prefer the AI mockup image for this placement; fall back to flat artwork
        const mockupEntry = state.mockupPlacements?.find(
          (p) => p.placementKey === key && p.imageUrl
        );
        const previewSrc = mockupEntry?.imageUrl || logo?.dataUrl || null;
        const item = document.createElement('div');
        item.className = 'fs-placement-item';
        item.innerHTML = `
          <div class="fs-placement-item__preview${previewSrc ? ' fs-placement-item__preview--has-img' : ''}">
            ${previewSrc ? `<img src="${previewSrc}" alt="${label}">` : `<span class="fs-placement-item__empty-icon">🖼️</span>`}
          </div>
          <div class="fs-placement-item__name">${label}</div>
          <div class="fs-placement-item__meta">${logo ? logo.fileName : 'No artwork'}</div>
        `;
        placementsEl.appendChild(item);
      });
    }

    updateFooterPriceDisplay();
  }

  function calculateEstimatedPricing() {
    const totalQty = state.totalQuantity;
    const basePrice = state.selectedMethodPrice || 0;
    const extraLocations = Math.max(0, state.selectedLocations.length - 1);
    const locationChargePerUnit = extraLocations * CONFIG.additionalLogoPrice;
    const extendedSizeChargePerUnit =
      state.extendedSizeCount > 0 ? (state.extendedSizeCount * CONFIG.extendedSizeSurcharge) / totalQty : 0;
    const pricePerUnit = basePrice + locationChargePerUnit + extendedSizeChargePerUnit;
    const subtotal = pricePerUnit * totalQty;
    return {
      basePrice,
      locationChargePerUnit,
      extendedSizeChargePerUnit,
      pricePerUnit,
      subtotal,
    };
  }

  async function proceedToCheckout() {
    const btn = document.getElementById('atelier-checkout');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = 'Adding to cart...';
    try {
      await addToShopifyCart();
      closeModal();
      window.location.href = '/cart';
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Failed to add to cart. Please try again.');
      btn.disabled = false;
      btn.textContent = 'Proceed to Checkout';
    }
  }

  async function addToShopifyCart() {
    if (!state.selectedMethodVariantId) throw new Error('No variant selected');
    const items = [];
    const sizeBreakdownText = Object.entries(state.sizeBreakdown)
      .map(([size, qty]) => `${size}(${qty})`)
      .join(', ');
    const mainLineItem = {
      id: state.selectedMethodVariantId,
      quantity: state.totalQuantity,
      properties: {
        'Print Method': state.selectedMethod,
        'Garment Color': state.selectedColor || 'Black',
        'Print Locations': state.selectedLocations.join(', '),
        'Size Breakdown': sizeBreakdownText,
        _configurator: 'atelier-v1',
      },
    };
    const designNames = getCheckedPlacements()
      .map((p) => state.placementLogos[p.key]?.fileName)
      .filter(Boolean);
    if (designNames.length) {
      mainLineItem.properties['Design files'] = designNames.join(', ');
    }
    if (state.specialInstructions) {
      mainLineItem.properties['Special Instructions'] = state.specialInstructions;
    }
    items.push(mainLineItem);
    const extraLocations = Math.max(0, state.selectedLocations.length - 1);
    if (extraLocations > 0 && state.additionalLogoVariantId) {
      items.push({
        id: state.additionalLogoVariantId,
        quantity: extraLocations * state.totalQuantity,
        properties: {
          _for_order: state.productData.product.title,
          _configurator: 'atelier-v1',
        },
      });
    }
    if (state.extendedSizeCount > 0 && state.extendedSizeVariantId) {
      items.push({
        id: state.extendedSizeVariantId,
        quantity: state.extendedSizeCount,
        properties: {
          _for_order: state.productData.product.title,
          _configurator: 'atelier-v1',
        },
      });
    }
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || errorData.message || 'Failed to add to cart');
    }
    return await response.json();
  }

  function requestQuote() {
    const subject = encodeURIComponent(
      `Quote Request: ${state.productData.product.title} (${state.totalQuantity} units)`
    );
    const body = encodeURIComponent(`
I would like to request a quote for:

Product: ${state.productData.product.title}
Print Method: ${state.selectedMethod}
Garment Color: ${state.selectedColor}
Print Locations: ${state.selectedLocations.join(', ')}
Total Quantity: ${state.totalQuantity}
Size Breakdown: ${Object.entries(state.sizeBreakdown).map(([s, q]) => `${s}: ${q}`).join(', ')}

Special Instructions:
${state.specialInstructions}
    `);
    window.location.href = `mailto:quotes@atelierfinery.com?subject=${subject}&body=${body}`;
  }

  // Expose public API for inline onclick handlers
  window.atelierInstance = {
    navigateTo: (step) => showStep(step),
    openModal,
    closeModal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
